var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3962_61700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 17.4033C10.9995 15.9446 11.579 14.5457 12.6104 13.5142C13.6419 12.4828 15.0408 11.9033 16.4995 11.9033C17.9582 11.9033 19.3571 12.4828 20.3886 13.5142C21.42 14.5457 21.9995 15.9446 21.9995 17.4033C21.9995 18.862 21.42 20.261 20.3886 21.2924C19.3571 22.3239 17.9582 22.9033 16.4995 22.9033C15.0408 22.9033 13.6419 22.3239 12.6104 21.2924C11.579 20.261 10.9995 18.862 10.9995 17.4033V17.4033Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 28.4033C-0.000488281 26.9446 0.578974 25.5457 1.61042 24.5142C2.64187 23.4828 4.04082 22.9033 5.49951 22.9033H10.9995V28.4033C10.9995 29.862 10.42 31.261 9.3886 32.2924C8.35715 33.3239 6.9582 33.9033 5.49951 33.9033C4.04082 33.9033 2.64187 33.3239 1.61042 32.2924C0.578974 31.261 -0.000488281 29.862 -0.000488281 28.4033H-0.000488281Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 0.90332V11.9033H16.4995C17.9582 11.9033 19.3571 11.3239 20.3886 10.2924C21.42 9.26096 21.9995 7.86201 21.9995 6.40332C21.9995 4.94463 21.42 3.54568 20.3886 2.51423C19.3571 1.48278 17.9582 0.90332 16.4995 0.90332L10.9995 0.90332Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 6.40332C-0.000488281 7.86201 0.578974 9.26096 1.61042 10.2924C2.64187 11.3239 4.04082 11.9033 5.49951 11.9033H10.9995V0.90332H5.49951C4.04082 0.90332 2.64187 1.48278 1.61042 2.51423C0.578974 3.54568 -0.000488281 4.94463 -0.000488281 6.40332H-0.000488281Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 17.4033C-0.000488281 18.862 0.578974 20.261 1.61042 21.2924C2.64187 22.3239 4.04082 22.9033 5.49951 22.9033H10.9995V11.9033H5.49951C4.04082 11.9033 2.64187 12.4828 1.61042 13.5142C0.578974 14.5457 -0.000488281 15.9446 -0.000488281 17.4033H-0.000488281Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3962_61700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 33,
    fill: "white",
    transform: "translate(0 0.907227)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma_logo.c1f87c70.svg";
export { ForwardRef as ReactComponent };